export const JOB_SKILLS = [
  ".NET C#",
  ".NETMAUI",
  "A/B tests",
  "ACID",
  "Actix",
  "Ada",
  "AdSense",
  "AdTech",
  "AI Guardrails",
  "AI model training",
  "AI prompt engineering",
  "Akamai CDN",
  "Alpine.js",
  "Amazon Athena",
  "Amazon Aurora",
  "Amazon Aurora PostgreSQL",
  "Amazon AWS",
  "Amazon CodeWhisperer",
  "Amazon Connect",
  "Amazon DocumentDB",
  "Amazon Elasticsearch Service",
  "Amazon EMR",
  "Amazon EventBridge",
  "Amazon Glue",
  "Amazon Polly",
  "Amazon Redshift Spectrum",
  "AMQP",
  "Android",
  "Angular",
  "Angular CLI",
  "Angular.js",
  "ANN",
  "Ansible",
  "Ant Design",
  "Apache ActiveMQ",
  "Apache Airflow",
  "Apache Flink",
  "Apache Gluten",
  "Apache Griffin",
  "Apache Hadoop",
  "Apache Hive",
  "Apache Iceberg",
  "Apache Kafka",
  "Apache Parquet",
  "Apache Spark",
  "Apache Trino",
  "ApacheTomcat",
  "Apollo Client",
  "Apollo GraphQL",
  "Apollo GraphQL Client",
  "Aqua Security",
  "ArgoCD",
  "ASP.NET",
  "Assembly",
  "Aurora MySQL",
  "Aurora PG vectors",
  "Aurora Serverless",
  "Aurora Solar",
  "AutoCAD",
  "AWS",
  "AWS ALB",
  "AWS API Gateway",
  "AWS Aurora Serverless",
  "AWS Batch",
  "AWS Bedrock",
  "AWS CloudFront",
  "AWS CloudTrail",
  "AWS CloudWatch",
  "AWS CodeBuild",
  "AWS CodeDeploy",
  "AWS Cognito",
  "AWS Comprehend",
  "AWS Direct Connect",
  "AWS DMS",
  "AWS DynamoDB",
  "AWS EBS",
  "AWS EC2",
  "AWS ECS Fargate",
  "AWS EFS",
  "AWS EKS",
  "AWS Elastic Beanstalk",
  "AWS Elastic Kubernetes Service",
  "AWS Elastic MapReduce",
  "AWS ElastiCache",
  "AWS ElasticCache",
  "AWS Elasticsearch",
  "AWS ELB",
  "AWS Fargate",
  "AWS Firehose",
  "AWS GenAI",
  "AWS Glacier",
  "AWS Glue",
  "AWS Glue Catalog",
  "AWS Glue ETL",
  "AWS IAM",
  "AWS Iceberg",
  "AWS IoT",
  "AWS Kafka",
  "AWS Kinesis",
  "AWS KMS",
  "AWS Lambda",
  "AWS Monitoring",
  "AWS NLB",
  "AWS Postgres",
  "AWS Redis",
  "AWS Redshift",
  "AWS Rekognition",
  "AWS Route 53",
  "AWS S3",
  "AWS Sagemaker",
  "AWS SES",
  "AWS SNS",
  "AWS Spark",
  "AWS SQS",
  "AWS SSM",
  "AWS Textract",
  "AWS WAF",
  "AWS_CDK",
  "AWS_ECS",
  "AWSCodePipeline",
  "AWS-ECR",
  "AWSNeptune",
  "AWS-VPC",
  "Axum",
  "Azure",
  "Azure ADF",
  "Azure Advisor",
  "Azure AI Search",
  "Azure AI services",
  "Azure AKS",
  "Azure Analysis Services",
  "Azure API Gateway",
  "Azure API Management",
  "Azure App Service",
  "Azure Application Gateway",
  "Azure Application Insights",
  "Azure Arc",
  "Azure Automation",
  "Azure Backup",
  "Azure Blob Storage",
  "Azure Bot Service",
  "Azure CDN",
  "Azure Computer Vision",
  "Azure Container Instances",
  "Azure Cosmos DB",
  "Azure Cost Management",
  "Azure Data Bricks",
  "Azure Data Explorer",
  "Azure Data Lake",
  "Azure Database",
  "Azure Databricks Workflows",
  "Azure DevOps CI/CD",
  "Azure Disks",
  "Azure DocumentDB",
  "Azure Event Grid",
  "Azure Event Hubs",
  "Azure ExpressRoute",
  "Azure Fabric",
  "Azure Files",
  "Azure Firewall",
  "Azure Front Door",
  "Azure HDInsight",
  "Azure HDInsight Spark",
  "Azure IAM",
  "Azure IoT Hub",
  "Azure Kubernetes",
  "Azure Load Balancer",
  "Azure Log Analytics",
  "Azure Logic Apps",
  "Azure Machine Learning",
  "Azure Migrate",
  "Azure Monitoring",
  "Azure Policy",
  "Azure PostgreSQL",
  "Azure Private Link",
  "Azure Redis Cache",
  "Azure Resource Manager",
  "Azure Sentinel",
  "Azure SQL Managed Instance",
  "Azure Static Web Apps",
  "Azure Storage Accounts",
  "Azure Stream Analytics",
  "Azure Synapse Analytics",
  "Azure Virtual Machines",
  "Azure Virtual Network",
  "Azure VPC",
  "Azure WAF",
  "AzureBatch",
  "AzureML",
  "AzureQueue",
  "AzureSQL",
  "Backbone.js",
  "Bash",
  "Bastion",
  "BedrockKB",
  "BI Visualization",
  "BigQuery",
  "Biology",
  "Bitbucket Pipelines",
  "Blazor",
  "Blockchain",
  "BullMQ",
  "Bun",
  "Bun.js",
  "C++",
  "CAD",
  "Catalog",
  "CDN",
  "Cesium",
  "Chakra UI",
  "chart.js",
  "Check Point firewalls",
  "Chef",
  "CI/CD",
  "CircleCI",
  "Cisco Secure Firewall",
  "Cloud (Azure, GCP, AWS)",
  "cloud AI",
  "Cloud Monitoring",
  "Cloudflare",
  "Cloudflare CDN",
  "Cloudflare WAF",
  "CloudFormation",
  "CloudTrace",
  "CNN",
  "CodeIgniter",
  "Context Window Management",
  "Cron",
  "CRUD",
  "CryEngine",
  "CSS",
  "Cursor",
  "Cypress",
  "D3.js",
  "DAG workflows",
  "Dart",
  "Dashboard Design",
  "Data Cube",
  "Data Dog",
  "Data Fabric",
  "data governance",
  "Data Lake",
  "Data Processing",
  "Data Storytelling",
  "Data structure",
  "Databricks",
  "Databricks Autoloader",
  "Databricks Connect",
  "Databricks Delta Lake",
  "Databricks Delta Live Tables",
  "Databricks MLflow",
  "Databricks Notebooks",
  "Databricks SQL",
  "Databricks Unity Catalogue",
  "Dataproc",
  "dbt",
  "DDoS",
  "Deep learning",
  "Digital Ocean",
  "Digital Twins",
  "Django",
  "Django Admin",
  "Django Channels",
  "DjangoRESTFramework",
  "Docker",
  "Docker Compose",
  "EBS Jenkins",
  "Echo",
  "Elastic Search",
  "Elastic Stack",
  "Elixir",
  "ELT pipelines",
  "Embeddings",
  "Ember Charts",
  "Ember CLI",
  "Ember.js",
  "EMQX",
  "Enterprise Service Bus",
  "Envoy",
  "Envoy API Gateway",
  "Erlang",
  "Ethereum Virtual Machine",
  "ETL pipelines",
  "Express",
  "FastAPI",
  "Fastly CDN",
  "few shot learning",
  "Fiber",
  "Firewall Administration",
  "Firewall Management",
  "Flask",
  "Flask-Limiter",
  "Flink SQL",
  "Flutter",
  "Fortinet Firewalls",
  "FSx",
  "GCP Agent space",
  "GCP Analytics",
  "GCP Batch",
  "GCP BigTable",
  "GCP Cloud Functions",
  "GCP Cloud Run",
  "GCP Composer",
  "GCP Compute",
  "GCP Data Fusion",
  "GCP Dataflow",
  "GCP Dataform",
  "GCP Dataproc",
  "GCP GCS",
  "GCP IAM",
  "GCP KMS",
  "GCP ML",
  "GCP Monitoring",
  "GCP Operations Suite",
  "GCP Security Center",
  "GCP Spanner",
  "GCP TPU",
  "GCP Vertex AI",
  "GCP VPC",
  "GCP-GKE",
  "GDScript",
  "Generative AI",
  "Gin",
  "Git",
  "GitHub",
  "Github Action",
  "GitLab",
  "GitLab CI/CD",
  "Go",
  "Godot",
  "Google Analytics",
  "Google PubSub",
  "Grafana",
  "Graph Data Modeling",
  "Great Expectation",
  "Groovy",
  "Guardrails Bedrock",
  "HAPI FHIR",
  "Hapi.js",
  "Haproxy",
  "HashiCorp Sentinel",
  "HashiCorp Vault",
  "Helm",
  "HIPAA",
  "HITRUST",
  "Hypothesis Testing",
  "IAM",
  "IBM MQ",
  "Ionic",
  "Java",
  "Java Lambdas",
  "JavaScript",
  "Jenkins",
  "Jest",
  "JSON schema validation",
  "Julia",
  "Juniper firewall",
  "JUnit",
  "k8s",
  "KafkaStreams",
  "Keras",
  "Key Vaults",
  "Kinesis Firehose",
  "KMS",
  "Koa",
  "Kotlin",
  "KPI Shield",
  "Kubernetes",
  "LakeFS",
  "Lambda Architecture",
  "LambdaEdge",
  "LambdaTest",
  "LangChain",
  "Laravel",
  "Large Language Models",
  "LightGBM",
  "Linux",
  "Linux Bash",
  "Lit",
  "LLM",
  "LLM evaluation",
  "LLM Prompt Engineering",
  "Machine Learning Algorithms",
  "Matlab",
  "MATLAB Simulink",
  "Matplotlib",
  "Micronaut",
  "Microsoft Defender for Cloud",
  "Microsoft Entra ID",
  "Microsoft Excel",
  "Microsoft MQ",
  "MLflow",
  "Mocha",
  "Model Monitoring",
  "Move",
  "MoveIt",
  "MoveNet",
  "MQL",
  "MySQL",
  "Nest.js",
  "Next-Gen Firewall",
  "NextJS",
  "NGINX",
  "NgRx",
  "NLP",
  "Node",
  "non-relational data modeling",
  "NumPy",
  "Nuxt",
  "OCI Resource Manager",
  "Okta CIAM",
  "Okta IAM",
  "OneFS",
  "Open AI",
  "Open Policy Agent",
  "OpenCV",
  "OpenEBS",
  "Oracle Cloud",
  "Oracle EBS",
  "Oracle NoSQL",
  "Oracle SQL",
  "Palo Alto firewalls",
  "Pandas",
  "Performance Optimization",
  "PHP",
  "PHPUnit",
  "Pinecone",
  "Playwright",
  "PostgreSQL",
  "Powershell",
  "Preact",
  "PrestoSQL",
  "Prometheus",
  "Prompt engineering",
  "prompt shielding",
  "PromQL",
  "Pulumi",
  "Puppet",
  "Puppeteer",
  "Pytest",
  "Python",
  "Python 3",
  "Python pytest",
  "PyTorch",
  "PyTorch Lightning",
  "PyTorch Mobile",
  "Qlik SQL",
  "Quarkus",
  "R",
  "Rabbit MQ",
  "RAG",
  "Rapid SQL",
  "React",
  "React Native",
  "React Native Testing Library",
  "React Testing",
  "React Three Fiber",
  "Red Hat OpenShift",
  "Redis",
  "RedisQueues",
  "Redshift Serverless",
  "Redux",
  "Redux Saga",
  "Redux Toolkit",
  "Relay",
  "Remix",
  "Rocket",
  "RocketMQ",
  "RQ",
  "Ruby",
  "Ruby on Rails",
  "Rust",
  "Salesforce data modeling",
  "SAS SQL",
  "Scala",
  "Scala Test",
  "Scientific data modeling",
  "Scikit",
  "Secrets Manager",
  "Selenium",
  "SentinelOne",
  "Serverless framework",
  "Shield",
  "Sinatra",
  "SMQT Certification",
  "Snowflake",
  "Snowflake data modeling",
  "Snowflake SQL",
  "Snyk",
  "Solidity",
  "SolidJS",
  "SonarQube",
  "Spark SQL",
  "Splunk",
  "Spring Boot",
  "Spring MVC",
  "Spring MVC Rest",
  "SQL",
  "SQL Data Modeling",
  "SQLServer",
  "Structured Output Design",
  "Svelte",
  "Swift",
  "SwiftTest",
  "SwiftUI",
  "SWR",
  "Symfony",
  "systemd",
  "Tabular Data Modeling",
  "Temporal data modeling",
  "TensorFlow",
  "TensorFlow.js",
  "Terraform",
  "TestNG",
  "Traefik",
  "Traffic manager",
  "Transactional data modeling",
  "Trivy",
  "TypeScript",
  "Unity",
  "UNIX Bash",
  "Unreal Engine",
  "Unstructured Data Modeling",
  "Vanilla PHP",
  "Vector Database Operations",
  "Vertica SQL",
  "Virtual Network",
  "Visual C#",
  "VPN Gateway",
  "Vue",
  "Vue CLI",
  "Vuex",
  "Windows Server",
  "Xamarin",
  "XGBoost",
  "Zero Trust",
  "ZeroMQ",
  "Zig",
  "Zigbee",
];
